// extracted by mini-css-extract-plugin
module.exports = {"time":"styles_time__4iZd5"};